/**
 *
 * @module entry
 * @desc {SDK.Status} entry point
 *
 */

import TemporaryAccess from './temporaryAccess';

/**
 *
 * @typedef SDK.Status
 * @type {Object}
 *
 * @property {TemporaryAccess} TemporaryAccess
 *
 */

/**
 *
 * @type {SDK.Status}
 *
 */
export default {

    TemporaryAccess

};



// WEBPACK FOOTER //
// ./src/status/entry.js